import { createCompoundComponent } from '@lounge-fe/ui-kit'
import { SubNavigation as BaseSubNavigation } from './SubNavigation'
import { Header } from './Header'

export const SubNavigation = createCompoundComponent(BaseSubNavigation, {
  Header,
})
